import React, {useState , useEffect} from "react";
import PersonalInfoUpdate from '../Components/PersonalInfoUpdate';
import '../Styles/RegistrationPortal.scss'
import { useNavigate } from "react-router-dom"
import MedicalComboUpdate from '../Components/MedicalComboUpdate';
import {Helmet} from "react-helmet";
// import '../Styles/AccountTypeSelection.scss';

function UpdateIndividualInformation()
{

const navigate = useNavigate()

const [page1Next, setPage1Next] = useState(0);

const [existingIndividualData, setexistingIndividualData] = useState({});

const [personalInformation, setPersonalInformation] = useState({
   first_name: '',
   last_name: '',
   gender: '',
   mail_addr_1: '',
   mail_city: '',
   mail_state: '',
   mail_zip: '',
   phone_num: '',
   emergency_cont_name: '',
   emergency_cont_rel: '',
   emergency_cont_num: '',
   birth_date: ''
});
/*                          Handle Medical Information                             */ 

const [medicalInformation, setMedicalInformation] = useState({
   insurance_cmpy: '',
   insurance_id_num: '',
   insurance_group_num: '',
   policy_holder_name: '',
   policy_holder_bd: '',
   last_tetanus_shot_dt: '',
   has_diab_or_hypgly: 'off',
   has_heart_condition: 'off',
   has_epilepsy: 'off',
   has_env_allergies: 'off',
   has_heat_problme: 'off',
   has_thyroid_problem: 'off',
   has_lupus: 'off',
   has_high_bld_press: 'off',
   has_asthma: 'off',
   drug_allergy_name: '',
   drug_allergy_emergency_action: '',
   food_allergy_name: '',
   food_allergy_emergency_action: '',
   other_allergy_name: '',
   other_allergy_emergency_action: '',
   medication_name: '',
   medication_dose: '',
});

/*          SELECT THE INDIVIDUAL INFORMATION FROM THE CURRENT USER                */
const getUpdateInformation = async () => {
   try {

      /*          GET THE EMAIL ADDRESS AND ACCOUNT_ID OF THE CURRENT USER         */
      const response2 = await fetch('/api/get-user', {
         method: 'GET',
         headers: { "Content-Type": "application/json" }
      })

      if (response2.status === 400 || response2.status === 500) {
            throw new Error("Failed User Retrieval");
         }

      const account = await response2.json();

      // Get IndividualInformation
      const response = await fetch('/getindividualinformation', {
         method: 'POST',
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify(
            {
             email: account.user.email,
             medicalInformation,
             personalInformation,
             existingIndividualData
            }
         )
      })

      // This will be updated with UseEffect                       //
      const individualJSON = await response.json();
      const individualData = individualJSON.data[0];
      console.log("Individual Data",individualData)
      setexistingIndividualData(individualJSON.data[0]);

      setPersonalInformation({...personalInformation, 
         first_name:                      individualData.first_name,
         last_name:                       individualData.last_name,
         gender:                          individualData.gender,
         mail_addr_1:                     individualData.mail_addr_1,
         mail_city:                       individualData.mail_city,
         mail_state:                      individualData.mail_state,
         mail_zip:                        individualData.mail_zip,
         phone_num:                       individualData.phone_num,
         emergency_cont_name:             individualData.emergency_cont_name,
         emergency_cont_rel:              individualData.emergency_cont_rel,
         emergency_cont_num:              individualData.emergency_cont_num,
         birth_date:                      individualData.birth_date
         })

      setMedicalInformation({...medicalInformation, 
         policy_holder_bd:                individualData.policy_holder_bd,
         last_tetanus_shot_dt:            individualData.last_tetanus_shot_dt,
         insurance_cmpy:                  individualData.insurance_cmpy,
         insurance_id_num:                individualData.insurance_id_num,
         insurance_group_num:             individualData.insurance_group_num,
         policy_holder_name:              individualData.policy_holder_name,
         has_diab_or_hypgly:              individualData.has_diab_or_hypgly,
         has_heart_condition:             individualData.has_heart_condition,
         has_epilepsy:                    individualData.has_epilepsy,
         has_env_allergies:               individualData.has_env_allergies,
         has_heat_problem:                individualData.has_heat_problem,
         has_thyroid_problem:             individualData.has_thyroid_problem,
         has_lupus:                       individualData.has_lupus,
         has_high_bld_press:              individualData.has_high_bld_press,
         has_asthma:                      individualData.has_asthma,
         drug_allergy_name:               individualData.drug_allergy_name,
         drug_allergy_emergency_action:   individualData.drug_allergy_emergency_action,
         food_allergy_name:               individualData.food_allergy_name,
         food_allergy_emergency_action:   individualData.food_allergy_emergency_action,
         other_allergy_name:              individualData.other_allergy_name,
         other_allergy_emergency_action:  individualData.other_allergy_emergency_action,
         medication_name:                 individualData.medication_name,
         medication_dose:                 individualData.medication_dose
      })

   }
   catch (error) {
      console.error(error.message); 
      }
}

  useEffect (() => { 
   getUpdateInformation();
  }, []);

  // The dom is constantly being updated, so first_name does not know what to set itself to I think this is the problem //

  /*           SET THE INFORMATION TO REFLECT THE CURRENT USER                */


  /*          SUBMIT THE UPDATED INDIVIDUAL INFORMATION TO THE DATABASE         */

  const handleSubmit  = async () => {

   try {
      const response2 = await fetch('/api/get-user', {
         method: 'GET',
         headers: { "Content-Type": "application/json" }
      })

      if (response2.status === 400 || response2.status === 500) {
            throw new Error("Failed User Retrieval");
      }

      const account = await response2.json();
   
      console.log("PersonalInformationAfterUpdate", personalInformation)
      
   await fetch('/updateindividualinformation', {
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
         email: account.user.email,
         personalInformation,
         medicalInformation,
         existingIndividualData
    })
    
  })
  .then(
  navigate('/editreview')
  );
  
} 
catch (error) {
   console.log(error)
 }
}
     
   return (
        <div className="IndividualSignUp">
        <Helmet>
            <title>Update Individual Account - Camp Connect</title>
         </Helmet>
    {page1Next === 0 &&
       <div className="page1Container">
          <PersonalInfoUpdate 
          personalInformation={personalInformation} 
          setPersonalInformation={setPersonalInformation} 
          page1Next={page1Next} 
          setPage1Next={setPage1Next}/>
      </div>

    }
    {page1Next === 1 &&
       <div className="page2Container">
            <MedicalComboUpdate 
            medicalInformation={medicalInformation} 
            setMedicalInformation={setMedicalInformation} 
            page1Next={page1Next}
            setPage1Next={setPage1Next}
            handleSubmit={handleSubmit}/>
      </div>
    }
      </div>
   )
};

export default UpdateIndividualInformation; 
